import script from "./uniform-account-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./uniform-account-table.vue?vue&type=script&lang=ts&setup=true"

import "./uniform-account-table.vue?vue&type=style&index=0&id=64381107&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64381107"]])

export default __exports__